// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2U4py","alertIcon":"ConfirmModal_alertIcon__1dWsR"};